// extracted by mini-css-extract-plugin
module.exports = {"container":"AppPager__container___1IuOo","center":"AppPager__center___3LX7y"};